<template>
  <div class="container-dashboard-six-monthly-safety"   v-bind:class="{'run-loading':loadingData}">
      <div class="container-dashboard-content" v-if="loadingData==false">
        <div class="content">
          <b-container fluid>
            <b-row>
              <b-col cols="6">
                
                <b-card v-if="loadingData==false">
                    <b-card-header class=" bg-primary">
                        <h5 class="text-center">6 Monthly Safety Inspection</h5>
                    </b-card-header>
                    <b-card-body >
                        <b-row>
                            <b-col cols="4">
                                <h5 class="text-center">Division</h5>
                            </b-col>
                            <b-col cols="8">
                                <h5 class="text-center filter-link" @click="openFilterPopup">{{display_property_name}}</h5>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>

              </b-col>
              <b-col cols="6">
                <b-card>
                    <b-card-header class="bg-primary">
                        <h5 class="text-center">Issue Register</h5>
                    </b-card-header>
                    <b-card-body >
                        <b-row>
                            <b-col cols="4">
                                <h5 class="text-center">Division</h5>
                            </b-col>
                            <b-col cols="8">
                                <h5 class="text-center filter-link" @click="openFilterPopup">{{display_property_name}}</h5>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
                <b-col>&nbsp;</b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <b-row>
                  <b-col cols="4" v-for="item in master.data.job"  v-bind:key="item.job_status">
                      <tile :show="loadingData==false" :title="item.job_status" :number="item.count" 
                      :color="item.color" :backgroundColor="item.backgroundColor"  :headerBackgroundColor="item.headerBackgroundColor"
                      @tile-click="jobStatusTileClick"
                      ></tile>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="6">
                <div class="issue-table  bg-white">
                  <b-table class="mb-0 table-outline" responsive="sm" hover :items="master.data.issue_register" :fields="slaPriorityTableFields" head-variant="light">                  
                    <div slot="priority" slot-scope="item">
                      <span :style="{ color: item.item.color }">
                        {{item.item.priority}}
                      </span>
                    </div>          
                    <div slot="closed" slot-scope="item">
                      <span @click="openIssuePopup(item.item.priority,'Closed',item.item.closed)" class="hyper-link">{{item.item.closed}}</span>
                    </div>        
                    <div slot="new" slot-scope="item">
                      <span @click="openIssuePopup(item.item.priority,'New',item.item.new)" class="hyper-link">{{item.item.new}}</span>
                    </div>       
                  </b-table>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <b-card>
                    <b-card-body >
                        <b-row>
                            <b-col cols="6">
                                <h5 class="text-center">6 Monthly Safety Inspection Report</h5>
                            </b-col>
                            <b-col cols="6">
                                <h5 class="text-center filter-link" @click="openFilterPopup">{{display_start_date}}  to  {{display_end_date}}</h5>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
              </b-col>
              <b-col cols="6">
                <b-card>
                    <b-card-body >
                        <b-row>
                            <b-col cols="6">
                                <h5 class="text-center">Issue Report Period</h5>
                            </b-col>
                            <b-col cols="6">
                                <h5 class="text-center filter-link" @click="openFilterPopup">{{display_start_date}}  to  {{display_end_date}}</h5>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
        <b-modal id="modal-Filter" title="Filters" hide-footer :centered="true" v-model="modals.filter.open">
            <b-form>
                <b-row>
                    <b-col md="6">
                        <gofix-form-input-date
                            v-model="modals.filter.data.start_date"
                            label="Start Date">
                        </gofix-form-input-date>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input-date
                            v-model="modals.filter.data.end_date"
                            label="End Date">
                        </gofix-form-input-date>
                    </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <div class="property-tree">
                      <gofix-form-properties
                              label="Select Property"
                              :contract-id="master.contract_id"
                              :property-id="master.root_property_id"
                              valueFormat="object"
                              v-model="modals.filter.data.property"
                              >
                      </gofix-form-properties>
                    </div>
                  </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" :loading="modals.filter.loading" @click="applyFilter" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal id="modal-Issues" :title="modals.issue.data.title" hide-footer :centered="true" v-model="modals.issue.open" size='lg'>
          <div class="modalDashboardListWrapper">
            <b-table class="mb-0 table-outline" responsive="sm" hover :items="modals.issue.list" :fields="issueListTableFields" head-variant="light"  
              v-bind:class="{'run-loading':modals.issue.loading}" @row-clicked="issueListRowCick">                  
              <div slot="issue_description" slot-scope="item">
                <span>{{item.item.issue_description}}</span>
              </div> 
              <div slot="issue_register_time" slot-scope="item">
                <span>
                  {{item.item.issue_register_time}}
                </span>
              </div>  
              <div slot="location" slot-scope="item">
                <span>{{item.item.location}}</span>
              </div>     
            </b-table>
          </div>
        </b-modal>
        <b-modal id="modal-Jobs" :title="modals.job.data.title" hide-footer :centered="true" v-model="modals.job.open" size='lg'>
          <div class="modalDashboardListWrapper">
            <b-table class="mb-0 table-outline" responsive="sm" hover :items="modals.job.list" :fields="jobListTableFields" head-variant="light"  
              v-bind:class="{'run-loading':modals.job.loading}" @row-clicked="jobListRowCick">                  
              <div slot="job_number" slot-scope="item">
                <span>{{item.item.job_number}}</span>
              </div> 
              <div slot="planned_date" slot-scope="item">
                <span>
                  {{item.item.planned_date}}
                </span>
              </div>  
              <div slot="location" slot-scope="item">
                <span>{{item.item.location}}</span>
              </div>     
            </b-table>
          </div>
        </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
const tile = () => import('./dashboard-six-monthly-safety/tile.vue');
import moment from 'moment';

  export default {
    components: {
      tile
    },
    data: function() {
      return {
        loadingData: false,
        slaPriorityTableFields: {
          priority: {
            label: ''
          },
          closed: {
            label: 'Closed',
            class: 'text-center text-success'
          },
          new: {
            label: 'New',
            class: 'text-center text-warning'
          },
        },
        issueListTableFields: {
          location: {
            label: 'Property/Location',
            class: ''
          },
          issue_description: {
            label: 'Description',
            class: ''
          },
          issue_register_time: {
            label: 'Issue Date'
          },
        },
        jobListTableFields: {
          location: {
            label: 'Property/Location',
            class: ''
          },
          job_number: {
            label: 'Job Number',
            class: ''
          },
          planned_date: {
            label: 'Job Planned Date'
          },
        },
        jobStatusColorMappings: {
          PLANNED: {background_color: "#bdd7ee", header_background_color: "#c7ddf1", color:"black"},
          DUE: {background_color: "#ffffcc", header_background_color: "#ffffd9", color:"black"},
          EXPIRED: {background_color: "#ff0000", header_background_color: "#ff3c3c", color:"white"},
          VERIFIED: {background_color: "#ccffcc", header_background_color: "#dfffdf", color:"black"},
          ENDORSED: {background_color: "#ffffff", header_background_color: "#ffffff", color:"black"},
          COMPLETED: {background_color: "#ffffff", header_background_color: "#ffffff", color:"black"},
          CANCELLED: {background_color: "#ffffff", header_background_color: "#ffffff", color:"black"},
          INACTIVE: {background_color: "#ffffff", header_background_color: "#ffffff", color:"black"},
          STARTED: {background_color: "#ffffff", header_background_color: "#ffffff", color:"black"},
          END: {background_color: "#ffffff", header_background_color: "#ffffff", color:"black"},
          "REQUIRE SCHEDULING": {background_color: "#fce4d6", header_background_color: "#fde3d9", color:"black"},
        },
        slaPriortyColorMappings: {
          IMMEDIATE: { color: "#dc3545" },
          URGENT: { color: "#ffc107" },
          OTHERS: { color: "#28a745" },
        },
        master: {
          contract_id: 0,
          root_property_id: 0,
          tableItems: [],
          data: {
            job: {},
            issue_register: [],
          },
          filter: {
            start_date: null,
            end_date: null,
            property: null,
          },
        },
        init: true,
        modals: {
          filter: {
            open: false,
            loading: false,
            data: {
              start_date: null,
              end_date: null,
              property: null,
            }
          },
          issue: {
            open: false,
            loading: false,
            data: {
              priority: null,
              status: null,
            },
            list: []
          },
          job: {
            open: false,
            loading: false,
            data: {
              status: null,
            },
            list: []
          },
        }
      }
    },

    async created() {
        if(this.ClientContractID && this.ClientContractID.contract_terms){
            this.loadingData = true;
            this.master.contract_id = this.ClientContractID.id;
            this.loadRootProperty();
        }
    },

    computed: {
      display_start_date() {
        if(this.master.filter.start_date)
          return moment(this.master.filter.start_date).format('YYYY-MM-DD');
      },
      display_end_date() {
        if(this.master.filter.end_date)
          return moment(this.master.filter.end_date).format('YYYY-MM-DD');
      },
      display_property_name() {
        if(this.master.filter.property && this.master.filter.property.name)
          return this.master.filter.property.name;
      },
    },

    methods: {
      ...mapActions({
            getItems: 'DashboardSixMonthlySafetyController/getItems',
            getIssueItems: 'DashboardSixMonthlySafetyController/getIssueLists',
            getJobItems: 'DashboardSixMonthlySafetyController/getJobLists',
        }),
      async getIssueListData(){
        this.modals.issue.loading = true;
        var params={};
        params.client_contract_id = this.master.contract_id;
        params.property_id = this.master.filter.property.id;
        params.start_date = moment(this.master.filter.start_date).format('YYYY-MM-DD');
        params.end_date = moment(this.master.filter.end_date).format('YYYY-MM-DD');
        params.service_category_name = '6 Monthly Safety Hazard Inspection';
        params.issue_status = this.modals.issue.data.status;
        params.priority = this.modals.issue.data.priority;
        await this.getIssueItems(params)
              .then(response => {
                this.modals.issue.list = response.list;
                this.modals.issue.loading = false;
              })
              .catch(err => {
                this.$alertNotification("Can not load the list", "danger");
                this.modals.issue.loading = false;
                console.log(err);
              })

      },
      async getJobListData(){
        this.modals.job.loading = true;
        var params={};
        params.client_contract_id = this.master.contract_id;
        params.property_id = this.master.filter.property.id;
        params.start_date = moment(this.master.filter.start_date).format('YYYY-MM-DD');
        params.end_date = moment(this.master.filter.end_date).format('YYYY-MM-DD');
        params.service_category_name = '6 Monthly Safety Hazard Inspection';
        params.job_status = this.modals.job.data.status;
        await this.getJobItems(params)
              .then(response => {
                this.modals.job.list = response.list;
                this.modals.job.loading = false;
              })
              .catch(err => {
                this.$alertNotification("Can not load the list", "danger");
                this.modals.job.loading = false;
                console.log(err);
              })

      },
      async getSixMonthlySafetyData() {
        if(this.master.contract_id){
          var params={};

          if(this.master.filter.start_date == null){
            var enddate = moment();
            var startdate = moment(enddate.toDate()).subtract(365, "days");
            this.master.filter.start_date = startdate.toDate();
            this.master.filter.end_date = enddate.toDate();
            
            this.modals.filter.data.start_date = this.master.filter.start_date;
            this.modals.filter.data.end_date = this.master.filter.end_date;
          }

          params.client_contract_id = this.master.contract_id;
          params.property_id = this.master.filter.property.id;
          params.start_date = moment(this.master.filter.start_date).format('YYYY-MM-DD');
          params.end_date = moment(this.master.filter.end_date).format('YYYY-MM-DD');
          params.service_category_name = '6 Monthly Safety Hazard Inspection';

          await this.getItems(params)
              .then(response => {
                  this.loadingData = false;
                  this.master.data = response;

                  this.master.data.job.forEach(job => {
                    job.color = this.jobStatusColorMappings[job.job_status].color;
                    job.backgroundColor = this.jobStatusColorMappings[job.job_status].background_color;
                    job.headerBackgroundColor = this.jobStatusColorMappings[job.job_status].header_background_color;
                  });

                  this.master.data.issue_register.forEach(ir => {
                    var mappingCode = "OTHERS";
                    if(ir.priority.toUpperCase().includes('IMMEDIATE')){
                      mappingCode = "IMMEDIATE";
                    }
                    else if(ir.priority.toUpperCase().includes('URGENT')){
                      mappingCode = "URGENT";
                    }
                    ir.color = this.slaPriortyColorMappings[mappingCode].color;
                  });


              })
              .catch(err => {
                  this.$alertNotification("Can not load the dashboard", "danger");
                  console.log(err);
                  this.loadingData = false;
              })

        }
      },  
      async loadRootProperty(){
            await global.axios(`api/contracts/${this.master.contract_id}/tree-properties/0`, {
                method: "GET",
                data: {},
                headers: {
                    Accept: "application/json",
                }
            })
            .then(result => {
                this.master.root_property_id = result.data.data[0].id;
                this.master.filter.property = { id: result.data.data[0].id, name: result.data.data[0].name };
                this.modals.filter.data.property = { id: result.data.data[0].id, name: result.data.data[0].name };
                this.getSixMonthlySafetyData();
                this.init = false;
            })
            .catch(error => {
                this.init = false;
            });
        },
      applyFilter(){
        this.loadingData = true;
        this.modals.filter.open = false;
        this.master.filter.start_date = this.modals.filter.data.start_date;
        this.master.filter.end_date = this.modals.filter.data.end_date;
        this.master.filter.property = this.modals.filter.data.property;
        this.getSixMonthlySafetyData();
      },
      openFilterPopup(){
        this.modals.filter.data.start_date = this.master.filter.start_date;
        this.modals.filter.data.end_date = this.master.filter.end_date;
        this.modals.filter.data.property = this.master.filter.property;
        this.modals.filter.open = true;
      },
      openIssuePopup(priority,status,count){
        if(count != 0){
          this.modals.issue.data.priority = priority;
          this.modals.issue.data.status = status;
          this.modals.issue.data.title = 'Issue Register List of '+ priority + ' and ' + status;
          this.modals.issue.open = true;
          this.getIssueListData();
        }
      },
      issueListRowCick(row,index){
        let route = this.$router.resolve({ path: `/v2/issue-register/${row.id}` });
        window.open(route.href, '_blank');
      },
      jobStatusTileClick(status){
        this.modals.job.data.status = status;
        this.modals.job.data.title = 'Job List of '+ status;
        this.modals.job.open = true;
        this.getJobListData();
      },
      jobListRowCick(row,index){
        if(row.id){
          let route = this.$router.resolve({ path: `/v2/job-list/${row.id}` });
          window.open(route.href, '_blank');
        }
      },
    },
    watch: {
      ClientContractID: function(val, old){
          if(!val){
              this.$router.go();
          }
          else if((val && old && old.id && val.id !== old.id)||(!old && val)){
            this.loadingData = true;
            this.master.contract_id = this.ClientContractID.id;
            this.loadRootProperty();
          }
      }
    }
  }
</script>